export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrow-up-small.476c889f.svg","height":6,"width":10,"blurWidth":0,"blurHeight":0};